import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import TourDetail from "@/pages/TourDetail";
import PlaceDetail from "@/pages/PlaceDetail";
import Account from "@/pages/Account";
import AuthCallback from "@/pages/AuthCallback";
import { CustomerAuthProvider } from "@/lib/auth";
import { captureReferral } from "@/lib/api";

captureReferral();

function AppRouter() {
  const location = useLocation();
  // Google sign-in returns to {origin}/account#session_id=... — exchange it before any other route renders
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/tours/:slug" element={<TourDetail />} />
      <Route path="/places/:slug" element={<PlaceDetail />} />
      <Route path="/account" element={<Account />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <CustomerAuthProvider>
          <AppRouter />
        </CustomerAuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
